export function isExpiredByServerExp(
  expiresAtUtc?: string | null,
  skewSeconds = 5,
): boolean {
  if (!expiresAtUtc) return true;

  const expMs = Date.parse(expiresAtUtc); // UTC string -> ms
  if (Number.isNaN(expMs)) return true;

  const nowMs = Date.now();
  return nowMs >= expMs - skewSeconds * 1000;
}

/**
 * Backward compatible helper:
 * - If server expiry is available -> use it
 * - Else fallback to JWT exp decoding (your existing logic)
 */
export function isTokenExpired(
  token: string | null,
  expiresAtUtc?: string | null,
  skewSeconds = 5,
): boolean {
  // Prefer server exp (works even for opaque tokens)
  if (expiresAtUtc) return isExpiredByServerExp(expiresAtUtc, skewSeconds);

  // Fallback: decode JWT exp ONLY when needed
  if (!token) return true;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;

    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(payload)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    const obj = JSON.parse(json);
    const exp = Number(obj?.exp); // seconds
    if (!exp) return true;

    const now = Math.floor(Date.now() / 1000);
    return now >= exp - skewSeconds;
  } catch {
    return true;
  }
}
